<template>
  <div class="w-full sm:w-full md:w-1/3 lg:w-1/3 xl:w-1/3 mb-4">
    <vs-card
      id="warehouse_donut"
      class="vs-con-loading__container px-2 widget-card"
      style="position: relative"
    >
      <card-header :title="$t('widget_entries_by_warehouse_capacity')"></card-header>

      <vs-row>
        <vs-col class="body-card-widget">
            <donut-chart
              :chartId="'warehouse-donut'"
              :height="'275'"
              :series="series"
              :centerFontSize="'20px'"
              :valueFontSize="'20px'"
            />
        </vs-col>
      </vs-row>
    </vs-card>
  </div>
</template>

<script>
import DonutChart from '@/views/apps/accounting/components/DonutChart.vue'
import entry from '@/http/requests/entry'
import loading from '@/mixins/Loading.js'
import CardHeader from './CardHeader.vue'

export default {
  mixins: [loading],
  components: {
    DonutChart,
    CardHeader
  },
  computed: {
    isLoading() {
      return this.loading.warehouse_donut
    },
  },
  watch: {
    isLoading(val) {
      if (val) {
        this.openLoading('warehouse_donut')
      } else {
        this.closeLoading('warehouse_donut')
      }
    },
  },
  data() {
    return {
      colors: [],
      labels: [],
      series: [],
      permitList: [],
      params: {
        filter: 'pallets',
        status: ['1', '2', '4', '8'],
      },
      loading: {
        warehouse_donut: false,
        warehouse_center: false,
      },
    }
  },
  mounted() {
    this.getInfo()
  },
  methods: {
    getInfo() {
      this.getSeriesDonut()
      this.getCentralLabel()
    },
    getSeriesDonut() {
      this.loading.warehouse_donut = true
      entry
        .getFirstDonut(this.params.filter)
        .then((res) => {
          this.loading.warehouse_donut = false
          let arrayColors = []
          let labels = []
          let series = [0]
          let entries = res.data.data
          entries.forEach((item, index) => {
            series[index] = Number(item.total)
            labels[index] = item.ShortName
            arrayColors[index] = item.color
          })
          ApexCharts.exec(
            'warehouse-donut',
            'updateOptions',
            {
              fill: {
                colors: arrayColors,
              },
              legend: {
                markers: {
                  fillColors: arrayColors,
                },
              },
              labels: labels,
              series: series,
            },
            false,
            true
          )
        })
        .catch((err) => {
          this.loading.warehouse_donut = false
          console.log(err)
        })
    },
    getCentralLabel() {
      this.loading.warehouse_center = true
      entry
        .warehouseCapacityDonut()
        .then((res) => {
          let occupied_asigned_clients = Number(
            res.data.occupied_asigned_clients
          ).toFixed(2)
          let occupied_total = Number(res.data.occupied_all_clients).toFixed(2)
          ApexCharts.exec(
            'warehouse-donut',
            'updateOptions',
            {
              plotOptions: {
                pie: {
                  donut: {
                    labels: {
                      total: {
                        label: occupied_asigned_clients + ' %',
                        color: '#009c22',
                        formatter: function (w) {
                          return occupied_total + ' % Full'
                        },
                      },
                      value: {
                        color: '#bd2900',
                      },
                    },
                  },
                },
              },
            },
            false,
            true
          )
          this.loading.warehouse_center = false
        })
        .catch((err) => {
          console.log(err)
          this.loading.warehouse_center = false
        })
    },
  },
}
</script>